import { defineStore } from "pinia"
import { ref, computed } from "vue"
import { useApiStore } from "@/stores/api"

export const useMarkercategoryStore = defineStore(
	"markercategory",
	() => {
		const api = useApiStore()
		const markercategories = ref([])

		const reset = () => {
			markercategories.value = []
		}

		const loadMarkercategories = async () => {
			const response = await api.dispatchApiCall("get", `/api/v2/marker_categories`)
			if (!response) {
				return false
			}
			markercategories.value = response.data
			return true
		}

		const createMarkercategory = async (data) => {
			const response = await api.dispatchApiCall("post", `/api/v2/marker_categories`, data)
			return response.data
		}

		const updateMarkercategory = async (data) => {
			const response = await api.dispatchApiCall("patch", `/api/v2/marker_categories/${data.id}`, data)
			return response.data
		}

		const deleteMarkercategory = async (id) => {
			const response = await api.dispatchApiCall("delete", `/api/v2/marker_categories/` + id)
			return response.data
		}

		/* access helpers */

		const markercategoriesById = computed(() => {
			let returnArray = []
			markercategories.value.forEach((markercategory) => {
				returnArray[markercategory.id] = markercategory
			})
			return returnArray
		})

		return {
			reset,
			markercategories,
			markercategoriesById,
			loadMarkercategories,
			createMarkercategory,
			updateMarkercategory,
			deleteMarkercategory,
		}
	},
	{
		persist: true,
	}
)
